export const API_URL = process.env.REACT_APP_API_URL;


function buildQuery(params) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });
  const str = query.toString();
  return str ? `?${str}` : "";
}

// Квартиры + total_count + matched_count
export const getAlllRealEstate = async ({ id, offset = 0, saleRent } = {}) => {
  const query = buildQuery({ id, offset, sale_rent: saleRent });
  const res = await fetch(`${API_URL}/real-estate/alll${query}`);
  if (!res.ok) throw new Error("Failed to fetch real estate data");
  return res.json();
};

// Все таблицы по id менеджера/брокера + total_count
export const getAllRealEstateById = async (id, { offset = 0, saleRent } = {}) => {
  if (id === undefined || id === null) throw new Error("id is required");
  const query = buildQuery({ offset, sale_rent: saleRent });
  const res = await fetch(`${API_URL}/real-estate/by-id/${id}${query}`);
  if (!res.ok) throw new Error("Failed to fetch real estate by id");
  return res.json();
};


export const getAllRealEstate = async () => {
  const res = await fetch(`${API_URL}/real-estate/all`);
  if (!res.ok) throw new Error("Failed to fetch real estate data");
  return res.json();
};

export const getEstateById = async (id) => {
  const res = await fetch(`${API_URL}/real-estate/${id}`);

  if (!res.ok) {
    throw new Error("Failed to fetch estate");
  }

  return res.json();
};
// Получаем всех менеджеров
export const getManagers = async () => {
  const res = await fetch(`${API_URL}/real-estate/give_managers`);
  if (!res.ok) throw new Error("Failed to fetch managers");
  return res.json();
};

// Получаем всех брокеров
export const getBrokers = async () => {
  const res = await fetch(`${API_URL}/real-estate/give_brokers`);
  if (!res.ok) throw new Error("Failed to fetch brokers");
  return res.json();
};

export const insertManager = async (manager) => {
  const response = await fetch(`${API_URL}/real-estate/insert_managers`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(manager),
  });
  if (!response.ok) throw new Error("Failed to insert manager");
  return response.json();
};

export const insertBroker = async (broker) => {
  const response = await fetch(`${API_URL}/real-estate/insert_brokers`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(broker),
  });

  let data;
  try {
    data = await response.json();
  } catch (err) {
    throw new Error(
      `Server returned non-JSON response (status ${response.status})`
    );
  }
  if (!response.ok) {
    throw new Error(data.error || "Failed to insert broker");
  }

  return data;
};
export const getFilteredHouses = async (filters) => {
  // filters — объект с ключами, совпадающими с req.query
  const query = new URLSearchParams(filters).toString();
  const res = await fetch(`/real-estate/filtred_houses?${query}`);
  if (!res.ok) throw new Error("Failed to fetch houses");
  return res.json();
};

export const deleteRealEstate = async (id) => {
  try {
    const response = await fetch(`${API_URL}/real-estate/delete/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Delete failed");
    }

    const data = await response.json();
    console.log(data.message);
  } catch (error) {
    console.error(error);
  }
};

export const recoverRealEstate = async (id) => {
  try {
    const response = await fetch(`${API_URL}/real-estate/recover/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Recover failed");
    }

    const data = await response.json();
    console.log(data.message);
  } catch (error) {
    console.error(error);
  }
};

export const getDeleted = async () => {
  const res = await fetch(`${API_URL}/real-estate/get_all_deleted`);
  if (!res.ok) throw new Error("Failed to fetch brokers");
  return res.json();
};


export const updateEstate = async (type, id, formData) => {
  let endpoint = "";

  switch (type) {
    case "land":
      endpoint = `/real-estate/land/${id}`;
      break;
    case "apartment":
      endpoint = `/real-estate/apartment/${id}`;
      break;
    case "commercial":
      endpoint = `/real-estate/commercial/${id}`;
      break;
    case "house":
      endpoint = `/real-estate/house/${id}`;
      break;
    default:
      throw new Error("Unknown estate type: " + type);
  }

  try {
    const res = await fetch(`${API_URL}${endpoint}`, {
      method: "PUT",
      body: formData, // 🔴 ВАЖНО: FormData отправляем напрямую
      // НЕ ставим Content-Type, браузер сам ставит multipart/form-data
    });

    if (!res.ok) {
      const errorText = await res.text();
      console.error("SERVER ERROR:", errorText);
      throw new Error(errorText);
    }

    const result = await res.json();
    console.log("UPDATE SUCCESS:", result);
    return result;
  } catch (err) {
    console.error("UPDATE ERROR:", err);
    throw err;
  }
};

